// Packages:
import React, { memo, useMemo } from 'react';
import {  useSelector } from 'react-redux';


// Styles:
import { Body, Description, Field, NodeLabel, NodeWrapper, StyledHandle } from '../styles';
import BaseNode from '../BaseNode';
import { config } from './config';
import useNodeStyles from '../../../../hooks/useNodeStyles';


// Functions:
const AcuityNode = ({ data }) => {
  // Constants:
  const { id,action, label } = data;


  // State:
  const studio = useSelector((state) => state.studio);

  const isSelected = useSelector(
    (state) => state.studio.selectedNode?.id === id
  );

  const {computedLabelStyle,computedBodyStyle,computedWrapperStyle}=useNodeStyles({isSelected,config})

  // Return:
  return (
    <BaseNode data={data} config={config}>
    <NodeWrapper
      style={computedWrapperStyle}
      backgroundColor={'#FEFFFE'}
      borderColor={'#008060'}
    >
        {config.handleStyles.map((handle, index) => (
        <StyledHandle
            key={index}
            id={handle.properties.id}
            type={handle.properties.type}
            position={handle.properties.position}
            style={handle.style}
        />
        ))}
      <NodeLabel
        htmlFor="text"
        style={computedLabelStyle}
      >
        {label}
      </NodeLabel>
      <Body
        style={computedBodyStyle}
      >
        <Description>
      <Field isActive={isSelected} activeColor={'#00523D'} inActiveColor={'#008060'}>
        {action || (
            <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
            action
            </span>
        )}
        </Field>
        </Description>
      </Body>
    </NodeWrapper>
    </BaseNode>
  );
};

// Exports:
export default memo(AcuityNode);